const Star = () => {
    return(
        <span className="text-red-600 ps-0.5">*</span>
    );
};

export default Star;